<template>
  <div>
    <el-row type="flex" justify="end" v-if="search">
      <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
        <el-input :placeholder="$t('pesquisar')" prefix-icon="el-icon-search" v-model="filter"
          v-on:keyup.native.enter="tableData = []; list()">
          <el-button slot="append" icon="el-icon-search" @click="tableData = []; list()"></el-button>
        </el-input>
      </el-col>
    </el-row>
    <el-table :data="tableData" ref="tableData" stripe style="width: 100%" v-loading="loading" @row-click="rowClick">
      <el-table-column type="selection" width="50"></el-table-column>
      <el-table-column sortable prop="name" :label="$t('nome')"></el-table-column>
    </el-table>

  </div>
</template>

<script>
import { UserService } from "@/services/users/user.services";

export default {
  props: ['customer', 'search'],
  data: function () {
    return {
      tableData: [],
      loading: false,
      filter: "",
    };
  },
  methods: {
    rowClick(row, column, ev) {
      this.$refs.tableData.toggleRowSelection(row);
    },
    get() {
      return this.$refs.tableData.selection;
    },
    bycustomer(customer) {
      const vm = this;
      for (const customerId of customer) {
        const callData = this.$store.getters['users/customer'];
        if (!callData[customerId] || (callData[customerId] && callData[customerId].length === 0)) {
          vm.loading = true;
          UserService.customer(customerId)
            .then((response) => {
              vm.tableData.push(...response.sort((a, b) => a.name.localeCompare(b.name)).map(x => {
                return {
                  customer: customerId,
                  id: x.id,
                  name: x.name,
                }
              }));
              this.$store.commit('users/update', { customerId, userList: response });
            })
            .catch((error) => {
              this.$store.commit('users/update', { customerId, userList: null });
            })
            .finally(() => (vm.loading = false));
        } else if (callData[customerId] && callData[customerId].length > 0) {
          vm.tableData.push(...callData[customerId].map(x => {
            return {
              customer: customerId,
              id: x.id,
              name: x.name,
            }
          }));
        }
      }
    },
    list() {
      const vm = this;
      vm.loading = true;
      console.log('list', vm.filter)
      UserService.list(999999, 1, vm.filter)
        .then((response) => {
          vm.tableData.push(...response.records.sort((a, b) => a.name.localeCompare(b.name)).map(x => {
            return {
              customer: x.customer,
              id: x.id,
              name: x.name,
            }
          }));
        })
        .catch((error) => {
          this.$message({ type: "error", message: error });
        })
        .finally(() => (vm.loading = false));
    },
    role(data) {
      const vm = this;
      vm.loading = true;
      UserService.role(data)
        .then((response) => {
          vm.tableData.push(...response.records.sort((a, b) => a.name.localeCompare(b.name)).map(x => {
            return {
              customer: data,
              id: x.id,
              name: x.name,
            }
          }));
        })
        .catch((error) => {
          this.$message({ type: "error", message: error });
        })
        .finally(() => (vm.loading = false));
    },
    show(data, type) {
      const vm = this;
      vm.tableData = [];
      type === '1'
        ? vm.bycustomer(data)
        : type === '2'
          ? vm.list()
          : vm.role(data)

    },

  },
};
</script>